import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  toastOptions: externalToastOptions,
  ...props
}) => {
  const mergedToastOptions = {
    style: { marginTop: '60px', fontSize: '1.125rem', ...externalToastOptions?.style },
    classNames: {
      toast:
        "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
      description: "group-[.toast]:text-muted-foreground",
      actionButton:
        "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
      cancelButton:
        "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
      ...externalToastOptions?.classNames,
    },
  };

  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={mergedToastOptions}
      {...props} />
  );
}

export { Toaster, toast }
